<template>
  <div>
    <CRow class="h-100 w-100 align-items-center justify-content-md-center" style="position: absolute">
      <CCol md="6" class="text-center">
        <div>
          <img src="/img/security.gif" />
        </div>
        <div class="h5">{{ $t('auth.userNotAllowed.text') }}</div>
        <div class="mt-3">
          <CButton color="primary" :to="routeTo">
            {{ buttonText }}
          </CButton>
        </div>
        <div v-if="$route.params.organizationId" class="mt-3">
          <div class="text-uppercase">
            {{ $t('auth.userNotAllowed.or') }}
          </div>
          <div class="mt-3">
            <router-link :to="{ name: 'OrganizationSelection' }">
              {{ $t('auth.userNotAllowed.button.organizationSelection') }}
            </router-link>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
export default {
  created() {
    if (this.$route.params.organizationId) {
      this.routeTo = { name: 'home', params: { organizationId: this.$route.params.organizationId } }
      this.buttonText = this.$t('auth.userNotAllowed.button.goToDashboard')
    } else {
      this.routeTo = { name: 'OrganizationSelection' }
      this.buttonText = this.$t('auth.userNotAllowed.button.organizationSelection')
    }
  },
  data() {
    return {
      routeTo: {},
      buttonText: null,
    }
  },
}
</script>

<style>
html,
body {
  height: 100%;
}
</style>
